import { useState } from 'react';
import IE3R08Details from './IE3R08Details';
import NotificationsList from '../components/NotificationsList';

const IE3R08 = ({ notification }: { notification?: any }) => {
    const [location, setLocation] = useState<'list' | 'details'>('list');

    // Note: The results of a Consult ENS (IE3Q05) request, there is nothing to send back to customs.
    return location === 'list' ? (
        <NotificationsList
            code="IE3R08"
            description="ENS Consultation Results"
            onSeeDetails={() => setLocation('details')}
        />
    ) : (
        <IE3R08Details notification={notification} onBack={() => setLocation('list')} />
    );
};

export default IE3R08;
